import React from 'react';
import {observer, inject, IReactComponent} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {IChangePasswordStore} from './change-password.stores';
import {IAppRootStore} from '../../app.root.store';
import ChangePasswordLayoutComponent from './components/layout/index';

import '@techsee/techsee-ui-common/lib/_shared/icons.css';
import './components/layout/styles.scss';

interface ChangePasswordViewProps {
    changePasswordStore: IChangePasswordStore;
    rootStore: IAppRootStore;
}

@observer
export class ChangePasswordViewComponent extends TechseeBaseComponent<ChangePasswordViewProps> {
    renderInternal(): JSX.Element {
        const {changePasswordStore} = this.props;
        return (
            <ChangePasswordLayoutComponent
                controller={changePasswordStore.changePasswordController}
                accountLogo={changePasswordStore.accountLogo}
                localizationService={changePasswordStore.localizationService}
            />
        );
    }
}

export const ChangePasswordView = inject(
    'rootStore',
    'changePasswordStore'
)(ChangePasswordViewComponent) as IReactComponent;
